<template>
  <div class="widget">
    <div class="expandedSelection">
      <button class="close" @click="clearExpanded">Done</button>
      <div class="header">
        <div class="headerTitle">Booking</div>
      </div>
      <div class="customizeHeader">Session details</div>
      <div class="selectionInfo">
        <div class="section">
          <div class="sectionTitle">Session time</div>
          <div class="flexGroup">
            <div class="monthYear">
              {{ getMonthAndDate(expandedDateTimeMS) }}
            </div>
          </div>
          <div class="date">{{ getDayAndYear(expandedDateTimeMS) }}</div>
          <div class="time">{{ getSlotTimes(expandedDateTimeMS) }}</div>
        </div>
        <div class="section">
          <div class="sectionTitle">Session partner</div>
          <div class="details" v-if="expandedPartnerData && expandedPartnerData.metadata">
            <a
              :href="`/profile/${expandedPartnerData.metadata.ID}`"
              class="visitProfile"
            >
              Visit profile
            </a>
            <div class="profile">
              <div class="profileHeader">
                <ik-image
                  loading="lazy"
                  :transformation="[{ height: 60, width: 60 }]"
                  v-if="expandedPartnerData.metadata.profileImageUrl"
                  :src="expandedPartnerData.metadata.profileImageUrl"
                  class="picture"
                />
                <div v-else class="picture smallBorder">
                  <IconBase
                    icon-name="profile"
                    iconColor="#333"
                    viewBox="0 0 32 32"
                    width="100%"
                    height="100%"
                    strokeWidth="0px"
                    ><IconProfileImg
                  /></IconBase>
                </div>
                <div class="name">
                  {{ expandedPartnerData.metadata.displayName }}
                </div>
              </div>
              <div class="profileMeta" v-if="profile && ready">
                <div class="joinDate">Joined: {{ getJoinDate }}</div>
                <div class="sessionCount">{{ sessionCountText }}</div>
                <!-- <div class="info">
                  <div class="infoTitle">Bio</div>
                  <div class="infoContent" v-html="profile.bio"></div>
                </div> -->
                <!-- <div class="infoGroup">
                  <div class="userInfo">Preferences</div>
                  <div class="userInfo">Languages</div>
                </div> -->
              </div>
            </div>
          </div>
          <div v-if="matchPoolArray.length===0" class="empty">
            No one is booked here yet...
          </div>
          <div v-if="hasMorePeople">
            <div class="othersAvailable">
              Other available people for this time
            </div>
            <div v-for="(person) in getOtherAvailablePeople" :key="person.ID">
              <div class="option">
                <div class="optionMeta">
                  <ProfileImage
                    :height="700"
                    :width="700"
                    :imageHeight="32"
                    :imageWidth="32"
                    :marginRight="0"
                    :profileImageUrl="person.profileImageUrl"
                  />
                  <div class="name">
                    {{ person.displayName }}
                  </div>
                  <button
                    @click="swapPartner(person.ID)"
                    class="switch tooltip_container"
                  >
                    <div>Switch</div>
                    <div class="tooltip tooltip--top tooltip--middle">
                      <span class="tooltip_tip">Switch to person</span>
                    </div>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div v-else>Looks like no one else is booked here!</div>
        </div>
        <button class="openAdvanced" @click="clearExpanded">
          View advanced options
        </button>
        <div class="advanced" v-if="isLargeView">
          <div class="section">
            <div class="sectionTitle">Session meta</div>
            <div class="titleContainer">
              <input class="titleInput" placeholder="Add title" />
            </div>
            <button class="sectionButton">+ Add description</button>
          </div>
          <div class="section">
            <div class="sectionTitle">Advanced</div>
            <div class="flexGroup">
              <div>
                <div class="userInfo">Recurrence</div>
                <div class="time">Does not repeat</div>
              </div>
              <!-- <div>
                <div class="userInfo">Duration</div>
                <div class="time">{{ expanded.length }}m</div>
              </div> -->
            </div>
          </div>

          <!-- <div class="dateInfo">
        <div class="recurrence">
          <div class="option">Send request to same person?</div>
        </div>
      </div> -->
          <div class="section">
            <div class="flexGroup">
              <button class="sectionButton">+ Add task</button>
              <button class="sectionButton">+ Add note</button>
            </div>
            <!-- <div class="assign">Assign existing task</div>
        <button class="new">Create new task</button> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { formatSlotDate } from "../../../../utilities/dateFormatter";
import IconBase from "../../../../components/IconBase";
import IconProfileImg from "../../../../components/SVG/IconProfileImg";
import { getProfilePreview } from "../../CalendarRequests";
import { format } from "date-fns";
import ProfileImage from "../../../../components/ProfileImage";

export default {
  name: "SingleSelection",
  props: {
    // expanded: Object,
    expandedDateTimeMS: Number,
    prefer24HourFormat: Boolean,
    isLargeView: Boolean,
    matchPool: Object,
  },
  components: {
    IconBase,
    IconProfileImg,
    ProfileImage,
  },
  data() {
    return {
      ready: false,
      profile: null,
    };
  },
  computed: {
    ...mapState({
      calendarUsers: (state) => state.calendarUsers.users,
    }),
    matchPoolArray() {
      const pool = this.$store.state.matchPool.matchPoolUsers[this.expandedDateTimeMS]; 
      return pool ? pool : [];
    },
    expandedPartnerData() {
      if (this.matchPoolArray && this.matchPoolArray.length) {
        const match = this.matchPoolArray[0];
        const bestMatchMetadata = this.calendarUsers[match.matchableID];
        if (bestMatchMetadata) {
          return {
            metadata: bestMatchMetadata.metadata,
            preferences: bestMatchMetadata.preferences,
            session: match.session,
          };
        }
      }
      return null;
    },
    sessionCountText() {
      const count = this.profile.sessionCount;

      let sessionText = count === 1 ? "session" : "sessions";
      return `${count} ${sessionText}`;
    },
    getJoinDate() {
      const date = new Date(this.profile.createdAt);
      return format(new Date(date), `MMM d, y`);
    },
    hasMorePeople() {
      return this.matchPoolArray && this.matchPoolArray.length && this.matchPoolArray.length > 1;
    },
    /**
     * @return {Array} for every person in match pool for this datetime, the following object:
     *  {
     *    displayName: {String}
     *    profileImageUrl: {String}
     *  }
     */
    getOtherAvailablePeople() {
      console.log("@getOtherAvailablePeople stuff changed! ", this.matchPoolArray);
      if (this.matchPoolArray) {
        return this.matchPoolArray
          .slice(1) /* the selection is the first */
          .map(person => {
            const user = this.calendarUsers[person.matchableID];
            return {
              ID: user.metadata.ID,
              displayName: user.metadata.displayName,
              profileImageUrl: user.metadata.profileImageUrl
            }
          });
      }
      return [];
    },
    // getMicPreference() {
    //   const preferences = this.expanded.partner.preferences;
    //   const preference = 0;
    //   for (var i = 0; i < preferences.length; i++) {
    //     const pref = preferences[i];
    //     if (pref.name == "microphone") {
    //       preference = pref.preference;
    //       break;
    //     }
    //   }
    //   return preference;
    // },
    // getScreensharePreference() {},
    // getWorkTypePreference() {},
  },
  methods: {
    clearExpanded() {
      this.$emit("clearExpanded");
    },
    getSlotTimes(dateTimeMS) {
      // const SESSION_LENGTH_MS = this.expanded.length * 60 * 1000;
      const SESSION_LENGTH_MS = 50 * 60 * 1000;
      const slotStartTime = formatSlotDate(dateTimeMS, this.prefer24HourFormat);
      const slotEndTime = formatSlotDate(
        dateTimeMS + SESSION_LENGTH_MS,
        this.prefer24HourFormat
      );
      return slotStartTime + "-" + slotEndTime;
    },
    getMonthAndDate(dateTimeMS) {
      return format(new Date(dateTimeMS), `MMMM d`);
    },
    getDayAndYear(dateTimeMS) {
      return format(new Date(dateTimeMS), `EEEE, y`);
    },
    async getProfilePreview() {
      if (this.expandedPartnerData) {
        const profile = await getProfilePreview(this.expandedPartnerData.metadata.ID);
        if (profile && profile.previewData) {
          this.profile = profile.previewData;
        }
      }
      this.ready = true;
    },
    async swapPartner(partnerID) {
      const swapData = { partnerID, dateTimeMS: this.expandedDateTimeMS };
      this.profile = null;
      await this.$store.dispatch("matchPool/swapSelectionPartner", swapData);
      this.getProfilePreview();
    },
  },
  async mounted() {
    this.getProfilePreview();
  },
  // watch: {
  //   expanded: {
  //     async handler() {
  //       await this.getProfilePreview();
  //     },
  //     deep: true,
  //   },
  // },
};
</script>
<style scoped>
.widget {
  box-sizing: border-box;
  margin: 0 auto;
  width: 100%;
}

.expandedSelection {
  padding: 28px 26px;
  padding-bottom: 16px;
  background-color: #eef1f4;
  border: 1px solid #f1f1f2;
  background-color: #f3f6f8;
  display: flex;
  flex-direction: column;
  width: 324px;
  border-radius: 6px;
  box-sizing: border-box;
  margin: 0 auto;
  margin-top: 27px;
  background-color: #ffffff;
  border-color: #eaeaea;
  width: 90%;
  position: relative;
}

.expandedSelection .headerTitle {
  color: #585b5d;
  text-align: center;
  color: #2b2c2d;
  font-size: 24px;
}

.expandedSelection .customizeHeader {
  text-align: center;
  padding: 6px 0px;
  font-size: 15px;
  font-weight: 600;
}

.expandedSelection .section {
  padding-bottom: 10px;
  margin-bottom: 16px;
  border-bottom: 1px solid #efefef;
}

.expandedSelection .section:last-of-type {
  border-bottom: none;
}

.expandedSelection .selectionInfo {
  position: relative;
  padding-top: 18px;
}

.expandedSelection .monthYear {
  font-size: 24px;
  margin-left: 2px;
}

.expandedSelection .date {
  margin-top: 4px;
  margin-left: 2px;
}

.expandedSelection .sectionTitle {
  margin-bottom: 10px;
  font-size: 12px;
  font-weight: 800;
  text-transform: uppercase;
  color: #2d2d2d;
}

.expandedSelection .titleInput {
  font-size: 20px;
}

.expandedSelection .close {
  margin-left: auto;
  border-radius: 360px;
  padding: 2px 8px;
  font-weight: 700;
  position: absolute;
  right: 15px;
  top: 10px;
  box-sizing: border-box;
  background-color: #efefef;
  color: #2d2d2d;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  line-height: 18px;
  text-align: center;
  z-index: 9999;
  border: 1px solid #ccc;
  background-color: #fafafb;
  border-color: #e6e6e6;
  box-shadow: 0px 4px 4px 0px #f5f5f5;
}

.expandedSelection .openAdvanced {
  border-radius: 360px;
  padding: 2px 8px;
  font-weight: 700;
  box-sizing: border-box;
  background-color: #fafafb;
  color: #2d2d2d;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  line-height: 18px;
  text-align: center;
  z-index: 9999;
  border: 1px solid #e6e6e6;
  margin: 0 auto;
  /* box-shadow: 0px 4px 4px 0px #f5f5f5; */
  transition: 0.1s ease-in-out;
  margin-top: 20px;
}

.expandedSelection .openAdvanced:hover {
  transform: scale(1.02);
}

.expandedSelection .time {
  display: flex;
  font-size: 13px;
  text-align: center;
  border-radius: 360px;
  padding: 4px 10px;
  font-weight: 700;
  align-items: center;
  border-top: 0px;
  box-shadow: none;
  border: 1px solid #eaeaea;
  color: #2d2d2d;
  background-color: white;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  box-sizing: border-box;
  display: inline-block;
  margin-top: 8px;
  margin-left: -2px;
}

.expandedSelection .flexGroup {
  display: flex;
}

.expandedSelection .details {
  display: flex;
  /* align-items: center; */
  background-color: #ffffff;
  border-radius: 3px;
  padding: 12px 15px;
  /* box-shadow: 0px 1px 3px 0px #e8e8e8; */
  /* border-bottom: 2px solid #efefef; */
  border-radius: 14px;
  border: 1px solid #efefef;
  /* cursor: pointer; */
  position: relative;
  background-color: #fafafb;
  box-sizing: border-box;
  overflow: hidden;
  /* margin-top: 12px; */
  flex-direction: column;
}

.expandedSelection .expanded-details {
  background-color: transparent;
  box-shadow: unset;
}

/* .expandedSelection .details:hover {
  background-color: #f5f6f9;
  background-color: #f3f3f3;
} */

.expandedSelection .details:hover .cancel {
  display: block !important;
}

.expandedSelection .details .profile {
  display: flex;
  flex-direction: column;
}

.expandedSelection .details .profile .picture {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 44px;
  height: 44px;
  border-radius: 4px;
  border-radius: 360px;
  justify-content: center;
  box-sizing: border-box;
  -o-object-fit: cover;
  object-fit: cover;
  border: 2px solid #eaeaea;
  border-color: #e4e4e4;
}

.expandedSelection .details .empty {
  font-size: 17px;
  padding: 8px 10px;
  padding-left: 4px;
  font-weight: 600;
  color: #2d2d2d;
  white-space: nowrap;
  /* max-width: 135px; */
  overflow: hidden;
  text-overflow: ellipsis;
  box-sizing: border-box;
}

.expandedSelection .details .profile .name {
  font-size: 20px;
  padding: 8px 10px;
  font-weight: 600;
  color: #32373c;
  white-space: nowrap;
  max-width: 121px;
  overflow: hidden;
  text-overflow: ellipsis;
  box-sizing: border-box;
  display: flex;
  align-items: center;
}

.expandedSelection .profileHeader {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 4px 0px;
  padding-bottom: 0px;
}

.expandedSelection .userInfo {
  padding-top: 10px;
  font-size: 14px;
  padding-left: 6px;
  font-weight: 700;
  color: #2d2d2d;
}

.expandedSelection .sectionButton {
  border-radius: 360px;
  border: 1px solid #eaeaea;
  font-weight: bold;
  display: flex;
  justify-content: center;
  font-size: 14px;
  /* margin-left: auto; */
  padding: 5px 8px;
  align-items: center;
  color: #323333;
  background-color: white;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  box-sizing: border-box;
  text-align: center;
  outline: none;
}

.expandedSelection .joinDate {
  font-size: 13px;
  text-align: center;
  margin: 0 auto;
  font-weight: 600;
  color: #2d2d2d;
}

.expandedSelection .sessionCount {
  text-align: center;
  font-size: 14px;
  border-radius: 360px;
  background-color: #2d2d2d;
  margin: 0 auto;
  color: white;
  justify-content: center;
  display: flex;
  align-items: center;
  padding: 4px 0px;
  margin-top: 6px;
  font-weight: 700;
  max-width: 112px;
}

.expandedSelection .infoTitle {
  padding-top: 19px;
  font-size: 14px;
  padding-left: 10px;
  font-weight: 700;
  color: #2d2d2d;
  margin-top: 10px;
  box-sizing: border-box;
  margin-left: auto;
  margin-right: auto;
}

.expandedSelection .intoContent {
  font-size: 16px;
  padding: 5px 10px;
  box-sizing: border-box;
  margin-left: auto;
  margin-right: auto;
}

.expandedSelection .visitProfile {
  border-radius: 360px;
  padding: 2px 8px;
  font-weight: 700;
  box-sizing: border-box;
  background-color: #ffffff;
  color: #2d2d2d;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  line-height: 18px;
  text-align: center;
  z-index: 9999;
  border: 1px solid #e6e6e6;
  margin: 0 auto;
  position: absolute;
  right: 8px;
  top: 8px;
}

.expandedSelection .option {
  display: flex;
  align-items: center;
  background-color: #ffffff;
  border-radius: 3px;
  padding: 5px 15px;
  border-radius: 360px;
  border: 1px solid #efefef;
  position: relative;
  background-color: #fafafb;
  box-sizing: border-box;
  /* overflow: hidden; */
}

.expandedSelection .optionMeta {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
}

.expandedSelection .option .name {
  font-size: 17px;
  padding: 8px 10px;
  font-weight: 600;
  color: #2d2d2d;
  white-space: nowrap;
  max-width: 121px;
  overflow: hidden;
  text-overflow: ellipsis;
  box-sizing: border-box;
  display: flex;
  align-items: center;
}

.expandedSelection .option .switch {
  border-radius: 360px;
  padding: 2px 8px;
  font-weight: 700;
  box-sizing: border-box;
  background-color: #ffffff;
  color: #2d2d2d;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  line-height: 18px;
  text-align: center;
  z-index: 9999;
  border: 1px solid #e6e6e6;
  margin-left: auto;
}

.expandedSelection .othersAvailable {
  text-align: center;
  font-weight: 600;
  padding: 6px 0px;
  margin-top: 12px;
  margin-bottom: 2px;
  font-size: 14px;
}

.tooltip {
  background: #2d2d2d;
  display: var(--tooltip-display);
  border-radius: 4px;
  color: white;
  filter: var(--tooltip-filter, none);
  flex-direction: row;
  flex-shrink: 0;
  font-weight: normal;
  font-size: 12px;
  padding: 6px 12px;
  position: absolute;
  text-align: center;
  transform: translate(var(--translateX, 0), var(--translateY, 0));
  white-space: nowrap;
  z-index: 900;
}
.tooltip::before {
  background: #2d2d2d;
  display: block;
  position: absolute;
  content: "";
  height: 8px;
  width: 8px;
  z-index: 1;
}
.tooltip--top {
  --translateY: calc(-100% - 8px);
  top: -4px;
}
.tooltip--top::before {
  bottom: 0;
  transform: rotate(45deg) translate(-50%, 50%);
  transform-origin: left bottom;
}
.tooltip--top.tooltip--middle {
  --translateX: -50%;
  left: 50%;
}
.tooltip--top.tooltip--middle::before {
  left: 50%;
}
.tooltip_container {
  --tooltip-display: none;
  position: relative;
}
@media (hover: hover) {
  .tooltip_container:hover {
    --tooltip-display: flex;
  }
}
</style>